import { SortOrder } from 'further-types/utils';

const sortSelectOptions = [
  {
    label: 'Most completions',
    value: 'mostCompletions',
  },
  {
    label: 'Least completions',
    value: 'leastCompletions',
  },
  {
    label: 'Highest commitment',
    value: 'highestCommitment',
  },
  {
    label: 'Lowest commitment',
    value: 'lowestCommitment',
  },
  {
    label: 'Name (A-Z)',
    value: 'nameAZ',
  },
  {
    label: 'Name (Z-A)',
    value: 'nameZA',
  },
];

const sortByOptionToOrderMap: Record<
  (typeof sortSelectOptions)[number]['value'],
  { orderBy: string; order: SortOrder }
> = {
  nameAZ: {
    orderBy: 'investorName',
    order: SortOrder.Asc,
  },
  nameZA: {
    orderBy: 'investorName',
    order: SortOrder.Desc,
  },
  highestCommitment: {
    orderBy: 'resolvedCommitmentAmount',
    order: SortOrder.Desc,
  },
  lowestCommitment: {
    orderBy: 'resolvedCommitmentAmount',
    order: SortOrder.Asc,
  },
  mostCompletions: {
    orderBy: 'completedStepsWeight',
    order: SortOrder.Desc,
  },
  leastCompletions: {
    orderBy: 'completedStepsWeight',
    order: SortOrder.Asc,
  },
};

export default function useOnboardingInvestorSort<
  T extends string,
>(pagination: {
  orderBy: T;
  order: SortOrder;
  handleChangeSort: (orderBy: T, order: SortOrder) => void;
}) {
  const sortSelectValue = Object.entries(sortByOptionToOrderMap).find(
    ([_, option]) =>
      option.orderBy === pagination.orderBy &&
      option.order === pagination.order,
  )?.[0];

  const handleChangeSort = (value: string) => {
    const orderBy = sortByOptionToOrderMap[value].orderBy;
    const order = sortByOptionToOrderMap[value].order;
    pagination.handleChangeSort(orderBy as T, order);
  };

  return {
    sortSelectOptions,
    sortSelectValue: sortSelectValue ?? 'nameAZ',
    handleChangeSort,
  };
}
